// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 策略包详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /strategy-package/info */
export async function strategyPackageInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyPackageInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyPackageInfoResp>('/strategy-package/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略包列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /strategy-package/list */
export async function strategyPackageListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyPackageListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyPackageSimpleResp>('/strategy-package/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
